import { render, staticRenderFns } from "./AppFooterBlack.vue?vue&type=template&id=2fa99482"
import script from "./AppFooterBlack.vue?vue&type=script&lang=js"
export * from "./AppFooterBlack.vue?vue&type=script&lang=js"
import style0 from "./AppFooterBlack.vue?vue&type=style&index=0&id=2fa99482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports